
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLogOutUser } from 'services/hooks/auth';
import { StyledIconButton } from './LoginButton.styles';



const LoginButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = localStorage.getItem('access');
  const logOutUser = useLogOutUser();

  const handleLoginClick = () => {
    navigate('/sign-in', {
      state: { 
        from: location.pathname + location.search,
        isSecurePortal: true
      }
    });
  };

  const handleLogoutClick = () => {
    logOutUser();
  };

  return (
    <Box>
      {isLoggedIn ? (
        <StyledIconButton aria-label="logout" onClick={handleLogoutClick}>
          Logout
          <AccountCircleOutlinedIcon />
        </StyledIconButton>
      ) : (
        <StyledIconButton aria-label="login" onClick={handleLoginClick}>
        Login
          <AccountCircleOutlinedIcon />   
        </StyledIconButton>
      )}
    </Box>
  )
};

export default LoginButton;